import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import { Tabs, Tab } from '@material-ui/core';
import { requestWpCategories } from './actions';
import { selectCategories } from './selectors';
import './style.scss';

class FilterCategory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabBarPosition: 'top',
      activeKey: 'all',
      start: 0,
      useIcon: false,
    };
  }

  componentWillMount() {
    let key = queryString.parse(this.props.location.search).category;
    if (!key) {
      key = 'all';
    }
    this.setState({
      activeKey: key,
    });
  }

  componentDidMount() {
    this.props.requestCategories();
  }

  onChange = (event, activeKey) => {
    console.log(activeKey);
    this.setState({ activeKey });
    this.props.history.push(`?category=${activeKey}`);
  };

  render() {
    const { categories } = this.props;

    return (
      <div style={{ display: 'block' }}>
        <Tabs
          value={this.state.activeKey}
          indicatorColor="primary"
          textColor="primary"
          onChange={this.onChange}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="Feed Categories"
        >
          { construct(categories) }
        </Tabs>
      </div>
    );
  }
}

const allowedCategories = [
  'Cigars 101',
  'Cigar Accessories',
  'Cigar Bars and Lounges',
  'Cigar Brands',
  'Cuban Cigars',
  'Featured',
];

function construct(categories) {
  const tabs = [];

  tabs.push(<Tab
    label="All"
    value="all"
  />);

  // FIXME How can we control their order - Cigars 101 should be first (after All)
  categories.map((item) => {
    if (allowedCategories.indexOf(item.name) !== -1) {
      return tabs.push(<Tab
        label={item.name}
        value={item.slug}
      />);
    }
    return null;
  });
  return tabs;
}

FilterCategory.propTypes = {
  location: PropTypes.object,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
  categories: PropTypes.object,
  requestCategories: PropTypes.func.isRequired,
};

FilterCategory.contextTypes = {
  theme: PropTypes.string,
};

const mapStateToProps = createStructuredSelector({
  categories: selectCategories(),
});

const mapDispatchToProps = (dispatch) => ({
  requestCategories: () => dispatch(requestWpCategories()),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FilterCategory));
